"use client"
import { useState, useEffect } from 'react'
import { Button } from "@/components/ui/button"
import { PlusIcon, ArrowLeft } from "lucide-react"
import { ProductService, columns } from "./columns"
import { DataTable } from "@/components/data-table"
import ProductServiceService from "@/api/productservices.service";
import { useToast } from '@/hooks/use-toast'
 
async function getData(toast: any, businessId: number): Promise<ProductService[]> {
  // Fetch data from your API here.
  const response = await ProductServiceService.getAllProductServices(businessId);
  if (response.data.result === 'invalid') {
    window.location.href = '/logout';
    return [];
  } else if (response.data.result === 'success') {
    console.log("response.data", response.data);
    return response.data.productServices.map((service: any) => ({
      id: service.id,
      publicId: service.publicId,
      name: service.name,
      description: service.description,
      unitPrice: service.unitPrice,
      currency: service.currency,
      timezone: service.timezone,
      dateUpdated: service.dateUpdated,
      dateCreated: service.dateCreated,
    }));
  } else {
    toast({
      title: "Error",
      description: response.data.message || "Failed to fetch product services",
      variant: "destructive",
    });
    return [];
  }
}

export default function ProductServices() {
  const [data, setData] = useState<ProductService[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const { toast } = useToast();

  const [selectedBusiness] = useState(() => {
    const storedBusiness = typeof window !== 'undefined' ? window.localStorage.getItem('selectedBusiness') : null;
    return storedBusiness ? JSON.parse(storedBusiness) : null;
  });

  useEffect(() => {
    const fetchData = async () => {
      const result = await getData(toast, selectedBusiness.id);
      setIsLoading(false);
      setData(result);
    };
    fetchData();
  }, []);

  return (
    <div className="container py-10 mx-auto bg-white px-10 rounded-lg">
      <h2 className="text-3xl font-bold tracking-tight">Product Services</h2>
      <div className='flex items-start align-middle'>
        <Button onClick={() => window.history.back()} className='mr-2'> 
          <ArrowLeft className="w-4 h-4 mr-2" /> Go Back</Button>
        <Button onClick={() => window.location.href=`/product-services/create`} className='bg-[#0E415E] text-white'>
          <PlusIcon className="w-4 h-4 mr-2" /> Create Product Service
        </Button>
      </div>
      <DataTable columns={columns} data={data} section="ProductServices" isLoading={isLoading} />
    </div>
  );
}
